import { render, staticRenderFns } from "./strategy-tpl-use-detail-modal.vue?vue&type=template&id=5116393e&scoped=true&"
import script from "./strategy-tpl-use-detail-modal.vue?vue&type=script&lang=js&"
export * from "./strategy-tpl-use-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./strategy-tpl-use-detail-modal.vue?vue&type=style&index=0&id=5116393e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116393e",
  null
  
)

export default component.exports